export const mt4Tutorials = [
  {
    slug: 'mt4-download-install',
    group: 'start',
    title: 'วิธีดาวน์โหลดและติดตั้ง MT4',
    minutes: 5,
    desc: 'ดาวน์โหลดตัวติดตั้ง MT4 จากโบรกเกอร์ที่คุณเปิดบัญชี แล้วติดตั้งลงเครื่องให้เสร็จภายในไม่กี่นาที',
    steps: [
      'เข้าเว็บไซต์ของโบรกเกอร์ที่ใช้บริการ เลือกเมนูดาวน์โหลดแพลตฟอร์ม แล้วเลือก MetaTrader 4 สำหรับ Windows หรือ macOS',
      'เปิดไฟล์ติดตั้งที่ดาวน์โหลดมา กด Next ตามค่าเริ่มต้นจนเสร็จ แล้วเปิดโปรแกรมขึ้นมาครั้งแรก',
      'ในหน้าต่างเริ่มต้น เลือก File > Login to Trade Account เพื่อเข้าสู่ระบบด้วยบัญชีที่โบรกเกอร์ส่งให้',
    ],
    note: 'ตัวติดตั้งจากแต่ละโบรกเกอร์จะฝังรายชื่อเซิร์ฟเวอร์มาให้อยู่แล้ว จึงควรโหลดจากโบรกเกอร์ที่ใช้จริง ไม่ใช่จากเว็บรวมไฟล์ดาวน์โหลด',
  },
  {
    slug: 'mt4-login-account',
    group: 'start',
    title: 'วิธีเข้าสู่ระบบบัญชีซื้อขาย MT4',
    minutes: 5,
    desc: 'การล็อกอิน MT4 ต้องกรอกเลขบัญชี รหัสผ่าน และเลือกเซิร์ฟเวอร์ให้ตรงกับที่โบรกเกอร์กำหนดไว้',
    steps: [
      'เปิด MT4 แล้วไปที่เมนู File > Login to Trade Account',
      'กรอก Login (เลขบัญชี), Password แล้วเลือก Server จากรายการที่ระบบแสดง',
      'กด Login และดูมุมขวาล่างของหน้าจอว่าขึ้นสถานะเชื่อมต่อพร้อมตัวเลข ping วิ่งอยู่',
    ],
    note: 'ถ้าเลือกเซิร์ฟเวอร์ผิด ระบบจะขึ้นว่า Invalid account แม้รหัสผ่านจะถูกต้อง ให้เทียบชื่อเซิร์ฟเวอร์จากอีเมลของโบรกเกอร์ก่อนทุกครั้ง',
  },
  {
    slug: 'mt4-screen-overview',
    group: 'start',
    title: 'ส่วนต่าง ๆ บนหน้าจอ MT4 มีอะไรบ้าง',
    minutes: 6,
    desc: 'หน้าจอ MT4 แบ่งเป็นสี่ส่วนหลัก คือ Market Watch, Navigator, กราฟกลางจอ และ Terminal ด้านล่าง',
    steps: [
      'Market Watch อยู่มุมซ้ายบน ใช้ดูราคาและเลือกรายการคู่เงินที่จะเปิดกราฟ',
      'Navigator อยู่มุมซ้ายล่าง เก็บรายการบัญชี อินดิเคเตอร์ และสคริปต์ที่ติดตั้งไว้',
      'Terminal อยู่ด้านล่าง เก็บแท็บ Trade, Account History และ Journal ที่ต้องใช้ตรวจสอบคำสั่งและข้อผิดพลาด',
    ],
    note: 'ถ้าเผลอปิดหน้าต่างใดไป ให้เปิดกลับผ่านเมนู View แล้วเลือกชื่อหน้าต่างนั้น ระบบจะจำตำแหน่งเดิมไว้ให้',
  },
  {
    slug: 'mt4-market-watch',
    group: 'start',
    title: 'วิธีใช้งานหน้าต่าง Market Watch ใน MT4',
    minutes: 6,
    desc: 'Market Watch คือรายการคู่เงินที่เราติดตาม ใช้เปิดกราฟและดูราคา Bid / Ask ที่อัปเดตตลอดเวลา',
    steps: [
      'กด Ctrl+M หรือไปที่ View > Market Watch เพื่อเปิดหน้าต่างนี้ขึ้นมา',
      'คลิกขวาในรายการแล้วเลือก Symbols เพื่อเพิ่มหรือลบคู่เงินที่ต้องการติดตาม',
      'ลากชื่อคู่เงินจาก Market Watch ไปวางบนกราฟ เพื่อสลับคู่เงินที่แสดงทันที',
    ],
    note: 'ยิ่งมีคู่เงินใน Market Watch มาก เครื่องยิ่งต้องประมวลผลมากขึ้น และราคาบางตัวอาจอัปเดตช้าลง ควรเก็บไว้เฉพาะคู่ที่เทรดจริง',
  },
  {
    slug: 'mt4-navigator-window',
    group: 'start',
    title: 'วิธีเปิดหน้าต่าง Navigator ใน MT4',
    minutes: 4,
    desc: 'Navigator ใช้เปิดกราฟใหม่ เรียกอินดิเคเตอร์ และเข้าเครื่องมือเสริมอย่าง Expert Advisor หรือสคริปต์',
    steps: [
      'กด Ctrl+N หรือไปที่ View > Navigator เพื่อเปิดแผงนี้',
      'คลิกขวาที่หัวข้อ Indicators แล้วเลือก Refresh เพื่อให้รายการอินดิเคเตอร์แสดงครบ',
      'ดับเบิลคลิกอินดิเคเตอร์ หรือลากลงบนกราฟ เพื่อเพิ่มเข้าไปในกราฟที่เปิดอยู่',
    ],
    note: 'ถ้าหัวข้อ Indicators ว่างเปล่าตอนเปิดโปรแกรมครั้งแรก ให้ปิดแล้วเปิด MT4 ใหม่ เพราะบางครั้งรายการโหลดไม่ครบ',
  },
  {
    slug: 'mt4-change-chart',
    group: 'chart',
    title: 'วิธีเปลี่ยนกราฟใน MT4',
    minutes: 5,
    desc: 'เปลี่ยนคู่เงินบนกราฟได้หลายวิธี ตั้งแต่ลากจาก Market Watch ไปจนถึงใช้ปุ่มลูกศรบนแป้นพิมพ์',
    steps: [
      'เปิดกราฟใหม่จาก File > New Chart แล้วเลือกคู่เงินและกรอบเวลาที่ต้องการ',
      'หรือลากชื่อคู่เงินจาก Market Watch มาวางบนกราฟเดิมเพื่อสลับทันที',
      'กดปุ่มลูกศรขึ้นหรือลงบนแป้นพิมพ์ เพื่อเลื่อนดูคู่เงินถัดไปในรายการ Market Watch',
    ],
    note: 'การเปลี่ยนคู่เงินจะรีเซ็ตอินดิเคเตอร์ที่ผูกกับกราฟเดิม ถ้าตั้งค่าไว้เยอะให้บันทึกเป็น Template ผ่าน Charts > Template ไว้ใช้ซ้ำ',
  },
  {
    slug: 'mt4-change-timeframe',
    group: 'chart',
    title: 'วิธีเปลี่ยนกรอบเวลาใน MT4',
    minutes: 4,
    desc: 'MT4 มีกรอบเวลาให้เลือก 9 แบบ ตั้งแต่ M1 ไปจนถึง MN1 เปลี่ยนได้ทั้งจากแถบเครื่องมือและเมนู Charts',
    steps: [
      'กดปุ่มกรอบเวลาบนแถบเครื่องมือด้านบน เช่น M15, H1 หรือ H4',
      'หรือไปที่เมนู Charts > Timeframe แล้วเลือกกรอบเวลาที่ต้องการ',
      'สังเกตชื่อกรอบเวลามุมซ้ายบนของกราฟ เพื่อยืนยันว่าเปลี่ยนถูกตัว',
    ],
    note: 'กรอบเวลายิ่งเล็ก กราฟยิ่งแกว่งถี่ มือใหม่ควรเริ่มอ่านที่ H1 หรือ H4 เพื่อเห็นโครงสร้างราคาชัดกว่า',
  },
  {
    slug: 'mt4-add-trendline',
    group: 'chart',
    title: 'วิธีเพิ่มเส้นแนวโน้มใน MT4',
    minutes: 6,
    desc: 'เส้นแนวโน้มใช้มองทิศทางของราคา วาดได้จากแถบเครื่องมือด้านบนหรือเมนู Insert > Objects',
    steps: [
      'คลิกไอคอนเส้นทแยงบนแถบเครื่องมือ หรือไปที่ Insert > Objects > Trendline',
      'คลิกจุดเริ่มต้นที่ต้องการ แล้วลากไปยังจุดสิ้นสุดของแนวโน้ม ปล่อยเมาส์เพื่อวางเส้น',
      'ดับเบิลคลิกที่เส้นเพื่อเปิดหน้าต่างปรับสี ความหนา และสไตล์ของเส้น',
    ],
    note: 'ควรวางเส้นจากจุดสูงหรือจุดต่ำที่เป็นที่จับตามองของตลาดจริง ไม่ใช่ลากให้พอดีตา เพราะเส้นที่วางตามใจจะให้สัญญาณผิด',
  },
  {
    slug: 'mt4-add-text',
    group: 'chart',
    title: 'วิธีเพิ่มข้อความลงในกราฟ MT4',
    minutes: 4,
    desc: 'การจดข้อความบนกราฟช่วยเตือนความจำเรื่องจุดเข้า เหตุผลในการเทรด และระดับราคาสำคัญ',
    steps: [
      'ไปที่ Insert > Text หรือกดปุ่มตัวอักษร A บนแถบเครื่องมือ',
      'คลิกตำแหน่งที่ต้องการบนกราฟ แล้วพิมพ์ข้อความลงไป จากนั้นกด Enter',
      'ดับเบิลคลิกข้อความเพื่อแก้ไข หรือลากย้ายตำแหน่งได้ตลอดเวลา',
    ],
    note: 'ข้อความจะติดกับกรอบเวลาที่วาดไว้ ถ้าเปลี่ยนกรอบเวลาข้อความอาจไม่แสดง ให้กลับไปที่กรอบเวลาเดิมหรือบันทึกเป็น Template',
  },
  {
    slug: 'mt4-manage-objects',
    group: 'chart',
    title: 'วิธีจัดการวัตถุที่วาดบนกราฟ MT4',
    minutes: 5,
    desc: 'เมื่อวาดเส้นและข้อความหลายชิ้น กราฟจะรกจนอ่านไม่ออก การจัดการวัตถุให้เป็นระเบียบจึงสำคัญ',
    steps: [
      'กด Ctrl+B หรือไปที่ Charts > Objects List เพื่อดูรายการวัตถุทั้งหมดบนกราฟ',
      'เลือกวัตถุที่ต้องการแล้วกด Edit เพื่อแก้ไข หรือ Delete เพื่อลบทิ้ง',
      'ถ้าต้องการซ่อนวัตถุชั่วคราวโดยไม่ลบ ให้ยกเลิกเครื่องหมายในช่อง Show',
    ],
    note: 'ก่อนลบวัตถุทั้งหมด ควรตรวจว่ามีเส้นแนวรับแนวต้านที่ยังใช้อยู่หรือไม่ เพราะรายการนี้ไม่มีปุ่มย้อนกลับ',
  },
  {
    slug: 'mt4-add-indicator',
    group: 'indicator',
    title: 'วิธีเพิ่มอินดิเคเตอร์ใน MT4',
    minutes: 6,
    desc: 'อินดิเคเตอร์ช่วยยืนยันจังหวะเข้าและออก เพิ่มได้จาก Navigator หรือเมนู Insert > Indicators',
    steps: [
      'ไปที่ Insert > Indicators แล้วเลือกหมวด เช่น Trend, Oscillators หรือ Volumes',
      'เลือกชื่ออินดิเคเตอร์ที่ต้องการ หน้าต่างตั้งค่าจะเปิดขึ้นก่อนวางบนกราฟ',
      'กด OK เพื่อยืนยัน อินดิเคเตอร์จะแสดงในกราฟหรือในหน้าต่างย่อยด้านล่างตามประเภท',
    ],
    note: 'เริ่มจากอินดิเคเตอร์ 1-2 ตัวที่เข้าใจหลักการจริงก่อน การติดตั้งหลายตัวพร้อมกันมักทำให้สัญญาณขัดกันจนตัดสินใจไม่ได้',
  },
  {
    slug: 'mt4-indicator-settings',
    group: 'indicator',
    title: 'วิธีตั้งค่าอินดิเคเตอร์ใน MT4',
    minutes: 6,
    desc: 'ค่า Period และระดับ Overbought / Oversold ของอินดิเคเตอร์ มีผลกับสัญญาณที่ได้มากกว่าที่คิด',
    steps: [
      'ดับเบิลคลิกที่เส้นอินดิเคเตอร์ หรือกด Ctrl+I เพื่อเปิดรายการอินดิเคเตอร์บนกราฟ',
      'เลือกอินดิเคเตอร์แล้วกด Edit เพื่อเปิดหน้าต่างตั้งค่า',
      'ปรับค่าในแท็บ Inputs และเปลี่ยนสีหรือความหนาได้ในแท็บ Colors',
    ],
    note: 'ค่าเริ่มต้นไม่ได้เหมาะกับทุกกรอบเวลา ถ้าเปลี่ยนกรอบเวลาควรทดสอบค่านั้นซ้ำบนกราฟย้อนหลังก่อนใช้งานจริง',
  },
  {
    slug: 'mt4-remove-indicator',
    group: 'indicator',
    title: 'วิธีลบอินดิเคเตอร์ออกจากกราฟ MT4',
    minutes: 3,
    desc: 'ลบอินดิเคเตอร์ที่ไม่ใช้แล้วออก เพื่อให้กราฟอ่านง่ายและลดภาระการประมวลผลของโปรแกรม',
    steps: [
      'กด Ctrl+I เพื่อเปิดรายการอินดิเคเตอร์ที่ใช้งานอยู่บนกราฟ',
      'เลือกตัวที่ต้องการลบ แล้วกดปุ่ม Delete',
      'หรือคลิกขวาที่เส้นอินดิเคเตอร์บนกราฟแล้วเลือก Delete Indicator',
    ],
    note: 'ถ้าลบแล้วกราฟยังดูแปลก ให้ตรวจว่าไม่ได้เหลือเทมเพลตเก่าที่โหลดกลับมาทุกครั้งที่เปิดกราฟใหม่',
  },
  {
    slug: 'mt4-open-order',
    group: 'order',
    title: 'วิธีเปิดคำสั่งซื้อขายใน MT4',
    minutes: 8,
    desc: 'การเปิดออเดอร์บน MT4 ใช้หน้าต่าง New Order ซึ่งต้องตรวจคู่เงิน ทิศทาง และขนาดล็อตให้ครบก่อนยืนยัน',
    steps: [
      'กด F9 หรือคลิกขวาที่กราฟแล้วเลือก Trading > New Order',
      'เลือก Symbol และกำหนด Volume ให้ตรงกับความเสี่ยงที่คำนวณไว้',
      'เลือก Buy หรือ Sell ตรวจราคาที่จะได้ แล้วกดปุ่ม Place เพื่อยืนยันคำสั่ง',
    ],
    note: 'ถ้าราคาเปลี่ยนเร็ว ระบบอาจขึ้น Requote ให้ตรวจราคาใหม่แทนการกดยืนยันซ้ำทันที เพราะราคาที่ได้อาจต่างจากที่เห็น',
  },
  {
    slug: 'mt4-set-sl-tp',
    group: 'order',
    title: 'วิธีตั้ง Stop Loss และ Take Profit ใน MT4',
    minutes: 6,
    desc: 'Stop Loss และ Take Profit คือสองช่องที่ควรกรอกทุกครั้งก่อนกดยืนยันคำสั่ง เพื่อจำกัดความเสี่ยงและล็อกกำไร',
    steps: [
      'ในหน้าต่าง New Order กรอกช่อง Stop Loss และ Take Profit เป็นระดับราคา ไม่ใช่จำนวนเงิน',
      'ตรวจระยะห่างขั้นต่ำของแต่ละคู่เงิน เพราะถ้าใกล้ราคาปัจจุบันเกินไป ระบบจะไม่ยอมรับ',
      'ถ้าเปิดออเดอร์ไปแล้ว ให้คลิกขวาที่ออเดอร์ในแท็บ Trade เลือก Modify เพื่อเติมค่าทีหลังได้',
    ],
    note: 'โบรกเกอร์บางแห่งไม่รับคำสั่งที่มี Stop Loss ใกล้ราคาเกินระยะที่กำหนด ให้เผื่อระยะไว้เล็กน้อยเสมอ',
  },
  {
    slug: 'mt4-edit-close-order',
    group: 'order',
    title: 'วิธีแก้ไขหรือปิดคำสั่งซื้อขายใน MT4',
    minutes: 6,
    desc: 'แก้ไขจุด Stop Loss และ Take Profit หรือปิดสถานะบางส่วนได้จากแท็บ Trade โดยไม่ต้องเปิดออเดอร์ใหม่',
    steps: [
      'เปิดแท็บ Trade ในหน้าต่าง Terminal ด้านล่างเพื่อดูออเดอร์ที่เปิดอยู่',
      'คลิกขวาที่รายการ เลือก Modify or Delete Order เพื่อแก้ไข Stop Loss และ Take Profit',
      'ถ้าต้องการปิด ให้เลือก Close Order แล้วยืนยันราคาที่ระบบเสนอ',
    ],
    note: 'การปิดออเดอร์บางส่วนทำได้โดยแก้ไข Volume ในหน้าต่าง Close Order แต่ขนาดที่เหลือต้องไม่ต่ำกว่าล็อตขั้นต่ำของคู่นั้น',
  },
  {
    slug: 'mt4-trade-history',
    group: 'order',
    title: 'วิธีดูประวัติการซื้อขายใน MT4',
    minutes: 5,
    desc: 'ประวัติการเทรดช่วยให้เห็นผลลัพธ์จริงของแต่ละออเดอร์ และใช้ตรวจสอบค่าสวอปกับคอมมิชชันได้',
    steps: [
      'เปิดแท็บ Account History ในหน้าต่าง Terminal',
      'คลิกขวาในช่วงว่าง เลือก All History หรือเลือกช่วงเวลาที่ต้องการ',
      'คลิกขวารายการที่สนใจแล้วเลือก Save as Report เพื่อเก็บไว้ทบทวนภายหลัง',
    ],
    note: 'ถ้าประวัติไม่ขึ้น ให้ตรวจว่ากรองช่วงวันที่อยู่ถูกช่วง และบัญชีที่ล็อกอินอยู่เป็นบัญชีที่เคยเทรดจริงหรือไม่',
  },
  {
    slug: 'mt4-chart-no-price',
    group: 'trouble',
    title: 'ทำไมกราฟ MT4 ไม่แสดงราคา',
    minutes: 5,
    desc: 'กราฟว่างหรือหยุดนิ่งมักมาจากการเชื่อมต่อหลุด ไม่ใช่โปรแกรมเสีย และแก้ได้ในไม่กี่ขั้นตอน',
    steps: [
      'ดูมุมขวาล่างของหน้าจอว่าสถานะเชื่อมต่อเป็นปกติหรือขึ้น No connection',
      'ถ้าหลุด ให้ตรวจอินเทอร์เน็ต แล้วไปที่ File > Login to Trade Account อีกครั้ง',
      'ถ้าเชื่อมต่อปกติแต่กราฟยังว่าง ให้คลิกขวาที่กราฟเลือก Refresh แล้วตรวจว่าคู่เงินนั้นยังเปิดให้เทรดอยู่',
    ],
    note: 'บางคู่เงินถูกปิดซื้อขายช่วงสุดสัปดาห์หรือวันหยุดของตลาด กราฟจะนิ่งโดยไม่ใช่ความผิดพลาดของแพลตฟอร์ม',
  },
  {
    slug: 'mt4-indicator-not-showing',
    group: 'trouble',
    title: 'วิธีแก้ปัญหาอินดิเคเตอร์ไม่แสดงใน MT4',
    minutes: 5,
    desc: 'อินดิเคเตอร์ที่เพิ่มแล้วไม่ขึ้นบนกราฟ ส่วนใหญ่เกิดจากกราฟไม่ได้รับอนุญาตหรือรายการยังโหลดไม่ครบ',
    steps: [
      'กด Ctrl+I ตรวจว่ารายการอินดิเคเตอร์มีชื่อนั้นอยู่จริงและไม่ได้ถูกตั้งเป็นซ่อน',
      'ตรวจว่าเส้นอินดิเคเตอร์ถูกวาดในหน้าต่างย่อยที่มองเห็น ไม่ได้ถูกซ่อนไว้ใต้กราฟอื่น',
      'ปิดแล้วเปิด MT4 ใหม่ แล้วกด Refresh ที่หัวข้อ Indicators ใน Navigator',
    ],
    note: 'อินดิเคเตอร์ที่เขียนขึ้นเองบางตัวใช้กับบิลด์ใหม่ไม่ได้ หากเพิ่งอัปเดตแพลตฟอร์มแล้วเพิ่งมีปัญหา ให้ตรวจเวอร์ชันของผู้พัฒนา',
  },
  {
    slug: 'mt4-cannot-login',
    group: 'trouble',
    title: 'ทำไมไม่สามารถเข้าสู่ระบบ MT4 ได้',
    minutes: 5,
    desc: 'ล็อกอินไม่ผ่านมีสาเหตุหลักอยู่ไม่กี่อย่าง ตั้งแต่รหัสผ่านผิด ไปจนถึงเลือกเซิร์ฟเวอร์ไม่ตรง',
    steps: [
      'ตรวจว่าเลือก Server ตรงกับชื่อในอีเมลของโบรกเกอร์ ไม่ใช่เซิร์ฟเวอร์ของโบรกอื่นที่อยู่ในรายการ',
      'พิมพ์รหัสผ่านใหม่โดยระวังตัวพิมพ์ใหญ่เล็ก และตรวจว่าไม่ได้เปิด Caps Lock ค้างไว้',
      'ถ้ายังไม่ผ่าน ให้ติดต่อโบรกเกอร์เพื่อยืนยันสถานะบัญชีและขอรีเซ็ตรหัสผ่าน',
    ],
    note: 'บัญชีทดลองมักหมดอายุหากไม่ได้ใช้งานนานหลายสัปดาห์ ล็อกอินไม่ผ่านในกรณีนั้นไม่ใช่รหัสผิด แต่ต้องเปิดบัญชีทดลองใหม่',
  },
];